module.exports = __webpack_public_path__ + "static/dotpedia-logo-80868c8e908b6ab69a49e783833c8a0d.png";